import { Component, Input, OnInit } from '@angular/core';
import { Transaction } from '../../../../../models/entities/transactions/transaction';
import { Payable } from '../../../../../models/entities/payable';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { LegFiJwtService } from '../../../../../services/auth/legfi-jwt.service';
import { JwtLegFiClaims } from '../../../../../services/auth/jwt-legfi-claims.model';
import { GrowlerService } from '../../../../shared/growler/growler.service';
import { PayablesService } from '../../../../../services/payables/payables.service';
import { finalize } from 'rxjs/operators';
import { LegfiDatePipe } from '../../../../../pipes/format/legfi-date.pipe';
import { LegfiCurrencyPipe } from '../../../../../pipes/format/legfi-currency.pipe';
import { PayableStatusBadgeComponent } from '../../../accounts-payable/payables-dashboard/payable-status-badge/payable-status-badge.component';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-payable-details',
    templateUrl: './payable-details.component.html',
    styleUrls: ['./payable-details.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        LegfiDatePipe,
        LegfiCurrencyPipe,
        PayableStatusBadgeComponent,
        RouterLink,
    ],
})
@UntilDestroy()
export class PayableDetailsComponent implements OnInit
{
    @Input() transaction: Transaction;

    jwt: JwtLegFiClaims;
    hasWriteAccess = false;
    hasReadAccess = false;
    dataLoading = true;
    showMemo = false;
    payable: Payable;

    constructor(
            private _payablesService: PayablesService,
            private _growler: GrowlerService,
    ) {
    }

    isPayable(reference: any): reference is Payable {
        return reference && (reference as Payable).invoiceDate !== undefined;
    }

    ngOnInit() {
        this.jwt = LegFiJwtService.read();
        this.hasReadAccess = LegFiJwtService.doesUserHaveModulePermission(
                'billpay',
                false,
        );
        this.hasWriteAccess = LegFiJwtService.doesUserHaveModulePermission(
                'billpay',
                true,
        );

        if (this.isPayable(this.transaction.reference) && this.hasReadAccess) {
            this.showMemo = this.transaction.reference.memo?.trim().length > 0;
            this.getPayable();
        }
    }

    getPayable(): void {
        if (this.isPayable(this.transaction.reference)) {
            this.dataLoading = true;
            this._payablesService.getPayable(this.transaction.reference.id).pipe(finalize(() => {
                this.dataLoading = false;
            }), untilDestroyed(this)).subscribe({
                next: (payable: Payable) => {
                    this.payable = payable;
                    this.payable.vendor.address1 = this.payable.vendor?.address1 || 'no address on file';
                    this.payable.vendor.address2 = this.payable.vendor?.address2 || null;
                    this.payable.vendor.name = this.payable.vendor?.name || 'no vendor name';
                    this.payable.vendor.nickname = this.payable.vendor?.nickname || null;
                    this.payable.vendor.city = this.payable.vendor?.city || 'no city';
                    this.payable.vendor.state = this.payable.vendor?.state || '--';
                    this.payable.vendor.zip = this.payable.vendor?.zip || 'no zip';
                }, error: () => {
                    this._growler.oops('There was a problem retrieving this payable');
                },
            });
        }
    }

}
